import React from 'react';

function SgCoverEndorsements(props) {
    const {
        quoteEndorsements
    } = props;

    return (
        <>
            { quoteEndorsements
            && (
                <div>
                    { quoteEndorsements.addons.length > 0
                    && (
                        <>
                            { quoteEndorsements.addons.map((addon) => {
                                return (
                                    <div>
                                        <h3 id="addonTitle"><b>{addon.coverageName}</b></h3>
                                        <ul>
                                            <li id="underwrittenBy">{addon.underwrittenScript}</li>
                                        </ul>
                                    </div>
                                );
                            })}
                        </>
                    )

                    }
                    { quoteEndorsements.newEndorsements
                    && quoteEndorsements.newEndorsements.map((endorsement, index) => {
                        return (
                            <ul id="endorsements">
                                <li id={`endorsementPoint${index}`}>{endorsement}</li>
                            </ul>
                        );
                    })
                    }
                </div>
            )
            }
        </>

    );
}

export default SgCoverEndorsements;
